export const getPageNumbers = (currentPage, totalPages, maxPagesToShow = 5) => {
  const pageNumbers = [];

  if (totalPages <= maxPagesToShow) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    pageNumbers.push(1);
    let startPage = Math.max(2, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(
      totalPages - 1,
      currentPage + Math.floor(maxPagesToShow / 2)
    );

    if (currentPage <= Math.ceil(maxPagesToShow / 2)) {
      endPage = maxPagesToShow - 1;
      if (endPage >= totalPages) endPage = totalPages - 1;
    } else if (currentPage + Math.floor(maxPagesToShow / 2) >= totalPages) {
      startPage = totalPages - maxPagesToShow + 2;
      if (startPage <= 0) startPage = 1;
    }

    if (startPage > 2) {
      pageNumbers.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    if (endPage < totalPages - 1) {
      pageNumbers.push("...");
    }

    if (totalPages > 1 && !pageNumbers.includes(totalPages)) {
      pageNumbers.push(totalPages);
    }
  }

  return pageNumbers;
};
